package top.wcpe.allincore.ui.runtime.render

import top.wcpe.allincore.layout.engine.Box
import top.wcpe.allincore.ui.runtime.crossplatform.RuntimeNodePaths
import top.wcpe.allincore.ui.runtime.element.UIElement
import top.wcpe.allincore.ui.runtime.render.UiRenderBridge
import top.wcpe.allincore.ui.runtime.render.layer.LayerBufferingBridge
import top.wcpe.allincore.ui.runtime.render.model.UiRenderZ

/**
 * 下拉覆盖层队列。
 */
internal class DropdownOverlayQueue {

    private val overlays = mutableListOf<DropdownOverlay>()

    fun add(element: UIElement<*>, box: Box, states: RenderStateStack.Snapshot, nodePath: String?) {
        overlays.add(DropdownOverlay(element, box, states, nodePath))
    }

    fun render(bridge: UiRenderBridge, registry: RendererRegistry) {
        if (overlays.isEmpty()) {
            return
        }
        // 面板要盖住同缓冲区里先画的内容，需要两件事：先 flush 拉开批次（平台层按 RenderType 分组
        // 提交，文本组恒晚于 GUI 矩形组），再抬一档 z（带阴影的文字正文被 vanilla 额外 +0.03，
        // 同档位的面板矩形会被 LEQUAL 深度测试拒绝）。层缓冲下录成屏障、回放时执行；直通真实桥时立即执行。
        val layerBridge = bridge as? LayerBufferingBridge
        if (layerBridge != null) {
            layerBridge.recordOverlayLift(UiRenderZ.DROPDOWN_PANEL_LIFT)
        } else {
            bridge.flush()
            bridge.pushZ(UiRenderZ.DROPDOWN_PANEL_LIFT)
        }
        try {
            for (overlay in overlays) {
                val renderer = registry.lookup(overlay.element)
                if (renderer is DropdownRenderer) {
                    RuntimeNodePaths.withCapture(bridge, overlay.nodePath) {
                        overlay.states.push(bridge)
                        try {
                            renderer.renderOverlay(overlay.element, overlay.box, bridge)
                        } finally {
                            overlay.states.pop(bridge)
                        }
                    }
                }
            }
        } finally {
            if (layerBridge != null) {
                layerBridge.recordOverlayRestore()
            } else {
                bridge.flush()
                bridge.popZ()
            }
        }
    }

    private class DropdownOverlay(
        val element: UIElement<*>,
        val box: Box,
        val states: RenderStateStack.Snapshot,
        val nodePath: String?,
    )
}
